var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCommentLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "njje7uyf9a",
    width: "188.9%",
    height: "188.9%",
    x: "-44.4%",
    y: "-44.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-302 -695) translate(302 569) translate(0 126)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.8,
    filter: "url(#njje7uyf9a)",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.275c2.547 0 4.854 1.033 6.523 2.702 1.67 1.67 2.702 3.976 2.702 6.523 0 1.261-.253 2.464-.711 3.559h0l.789 4.62-3.94-.673c-1.51 1.082-3.362 1.719-5.363 1.719-2.547 0-4.854-1.033-6.523-2.702-1.67-1.67-2.702-3.976-2.702-6.523 0-2.547 1.033-4.854 2.702-6.523 1.67-1.67 3.976-2.702 6.523-2.702z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentLive);
export default __webpack_public_path__ + "static/media/ic_comment_live.c1e97eacc705eaf5d06d75a2b0cd83f6.svg";
export { ForwardRef as ReactComponent };